import { Fab } from '@/components/elements/forms/buttons';
import MerchantLogo from '@/components/elements/MerchantLogo/MerchantLogo';
import Icon from '@/components/icons/Icon';
import PanelSlideOutView from '@/components/PanelSlideOutView/PanelSlideOutView';
import usePanelSlideOutViewManager from '@/components/PanelSlideOutView/PanelSlideOutView.hooks';
import { ROUTE_BUILDER } from '@/constants/pages';
import { _t } from '@/locale';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Card } from './AssociationDrawer.components';
import { UseAssociationDrawerManagerOutput } from './AssociationDrawer.types';

const AssociationDrawer = ({ place, open, onClose }: UseAssociationDrawerManagerOutput) => {
  const addressParts = [place?.address?.street, place?.address?.city].filter(Boolean);

  return (
    <PanelSlideOutView
      id="navigation-drawer"
      ariaLabelledby="association-drawer-title"
      {...usePanelSlideOutViewManager({ onClose, open })}>
      {place && (
        <Fragment>
          <div className="py-sm space-x-xs flex items-center">
            <Icon variant="industry-organization" color="fg_primary" />
            <h2 id="association-drawer-title" className="text-h-s text-fg_primary flex-1">
              {_t('Associations')}
            </h2>
            <Fab
              id="close-association-drawer"
              onClick={onClose}
              size="md"
              variant="borderless"
              aria-label={_t('close')}
              icon={<Icon variant="close" />}
            />
          </div>

          {/* Place  */}
          <section className="flex items-center">
            <div className="space-y-xs flex-1">
              <h3 className="text-fg_primary line-clamp-2 text-xl">{place?.name}</h3>
              <p className="text-fg_secondary text-s line-clamp-1">{addressParts.join(', ')}</p>
            </div>
            <div className="flex-shrink-0">
              <MerchantLogo
                alt=""
                size="lg"
                {...(place?.imageUrl && {
                  imgUrl: place.imageUrl,
                })}
              />
            </div>
          </section>

          <nav className="pt-xl">
            <ul className="gap-xs flex flex-col">
              {(place?.associations || []).map((association) => {
                return (
                  <li>
                    <Link
                      to={ROUTE_BUILDER.associationLanding(association.slug)}
                      aria-label={_t('readMore')}
                      onClick={onClose}>
                      <Card {...association} />
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </Fragment>
      )}
    </PanelSlideOutView>
  );
};

export default AssociationDrawer;
